/**
* 订单管理 交易订单
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>退款完成列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="用户id">
        <el-input size="small" v-model="formInline.userId" placeholder="用户id"></el-input>
      </el-form-item>
      <el-form-item label="订单id">
        <el-input size="small" v-model="formInline.orderId" placeholder="订单id"></el-input>
      </el-form-item>
      <el-form-item label="选泽日期：">
        <el-date-picker value-format='timestamp' v-model="formInline.value1" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="orderId" label="订单id" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="bz2" label="商家名称" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="type" label="退款类型" width="200" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.type == 1">直接退款</div>
          <div v-if="scope.row.type == 2">与商家确定是否能退</div>
        </template>
      </el-table-column>
      <el-table-column prop="reason" label="退款原因" width="200" show-overflow-tooltip>
      </el-table-column>

      <el-table-column prop="userId" label="退款用户id" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="platform" label="退款平台" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="bz3" label="订单金额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="refundAmount" label="退款金额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="createTime" label="退款时间" width="200" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{scope.row.createTime * 1000|timestampToTime}}</div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->

  </div>
</template>

<script>
  import {
    getOrderRefundPage,
    updateOrderRefundState
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '预览',
        editForm: {
          id: '',
          name: '',
          payType: 1,
          partner: '',
          subMchId: '',
          appid: '',
          notifyUrl: '',
          signType: '',
          partnerKey: '',
          sellerUserId: '',
          certPath: '',
          certPassword: '',
          rsaKey: '',
          token: localStorage.getItem('logintoken')
        },
        formInline: {
          page: 1,
          limit: 20,
          userId:'',
          orderId:'',
          value1:''
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(parameter) {

        // 模拟数据开始

        // 模拟数据结束
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "page": parameter.page,
          state:1,
          "pageSize": parameter.limit,
          "userId": parameter.userId,
          "orderId": parameter.orderId,
          "startDate": parameter.value1[0] / 1000,
          "endDate": parameter.value1[1] / 1000,
        }

        getOrderRefundPage(pro)
          .then(res => {
            this.loading = false
            if (res.code == 0) {
              this.listData = res.data.list
              // 分页赋值
              this.pageparm.currentPage = res.data.pageNum
              this.pageparm.pageSize = res.data.pageSize
              this.pageparm.total = res.data.total

            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('菜单加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      handleEdit(type, id) {
        let pro = {
          "data": {
            "state": type,
            "orderId": id,
          }
        }
        updateOrderRefundState(pro)
          .then(res => {
            this.getdata(this.formInline)
          })
      },

      xz(type, id) {
        if (type == 1) {
          this.$confirm('确定要退款吗?', '信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.handleEdit(type, id)
          })
        } else {
          this.$confirm('确定要拒绝吗?', '信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.handleEdit(type, id)
          })
        }


      },
      // 搜索事件
      search() {
        this.getdata(this.formInline)
      },

    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/channel/channelzu.vue